module.exports = {"513330100":"更庆镇","513330101":"马尼干戈镇","513330102":"竹庆镇","513330103":"阿须镇","513330104":"达马镇","513330105":"错阿镇","513330201":"普马乡","513330202":"岳巴乡","513330203":"八帮乡","513330204":"龚垭乡","513330205":"白垭乡","513330206":"汪布顶乡","513330207":"柯洛洞乡","513330208":"卡松渡乡","513330209":"俄南乡","513330211":"俄支乡","513330213":"玉隆乡","513330215":"中扎科乡","513330216":"然姑乡","513330217":"窝公乡","513330218":"温拖乡","513330219":"年古乡","513330220":"浪多乡","513330222":"打滚乡","513330223":"亚丁乡","513330224":"所巴乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513330.json
// module id = 2421
// module chunks = 0